module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "private-modal"
  }, [_c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "private popup",
      "translate-params": {
        date: _vm.date
      }
    }
  }, [_vm._v("\n        To see %{ date }, please login or become a member.\n      ")])], 1)]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.contribute
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Become a member")])], 1), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("I am already a member")])], 1), _vm._v(" "), _c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "private popup"
    }
  }, [_vm._v("\n        2 days a week are reserved to members\n      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "private popup"
    }
  }, [_vm._v(" Meteo-Parapente can exist thanks to you!\n      ")])], 1)]), _vm._v(" "), _c('p', [_c('small', [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n        My goal is to provide a quality tool accessible to every pilots.\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.aboutLink,
      "target": "_blank"
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "contribute popup"
    }
  }, [_vm._v("\n          Read more…\n        ")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d94a338e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/private.vue
// module id = 352
// module chunks = 1